import styled from 'styled-components';
import { Button } from '@cyberint/dsc';

// Banner uses a fixed dark palette regardless of page theme. `.dark-mode` ensures DSC components
// inside (e.g. Button.Filled) resolve their dark-mode CSS variables correctly.
export const Banner = styled.div.attrs({ className: 'dark-mode' })`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  gap: 16px;
  height: 40px;
  padding: 0 20px;
  background-color: var(--gunmetal);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  color: var(--darkMode-white);
  font-size: 13px;
`;

export const Notice = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.6);

  svg {
    color: rgba(255, 255, 255, 0.55);
  }
`;

export const ViewLabel = styled.span`
  color: var(--darkMode-white);
  font-weight: 600;
`;

export const ExitButton = Button.Filled;
